import { createSlice } from "@reduxjs/toolkit";

export const gameSlice = createSlice({
	name: "game",
	initialState: {
		roomCode: null,
		player: {
			id: "",
			name: "",
			role: "",
		},
		mainClaim: {
			mainClaim: "",
			phase: "land",
			convinced: [],
			notPersuaded: [],
		},
		reasonsToPlay: [],
		reasonInPlay: null,
		commonGrounds: {
			for: [],
			against: [],
		},
		results: null,
	},
	reducers: {
		setRoomCode: (state, action) => {
			return {
				...state,
				roomCode: action.payload.roomCode,
			};
		},
		initGame: (state, action) => {
			return {
				...state,
				roomCode: action.payload.roomCode,
				mainClaim: action.payload.mainClaim,
			};
		},
		setMainClaimState: (state, action) => {
			return {
				...state,
				mainClaim: action.payload,
			};
		},
		setPlayer: (state, action) => {
			return {
				...state,
				player: action.payload,
			};
		},
		changeGamePhase: (state, action) => {
			return {
				...state,
				mainClaim: {
					...state.mainClaim,
					phase: action.payload.phase,
				},
			};
		},
		setGameState: (state, action) => {
			return {
				...state,
				mainClaim: action.payload.mainClaim,
				reasonsToPlay: action.payload.reasonsToPlay,
				reasonInPlay: action.payload.reasonInPlay,
				commonGrounds: action.payload.commonGrounds,
			};
		},
		updateReasonsToPlay: (state, action) => {
			return {
				...state,
				reasonsToPlay: action.payload,
			};
		},
		addReasonToPlay: (state, action) => {
			const index = state.reasonsToPlay.findIndex(element => element.id === action.payload.id);
			if (index >= 0) {
				state.reasonsToPlay = [
					...state.reasonsToPlay.slice(0, index),
					action.payload,
					...state.reasonsToPlay.slice(index + 1),
				];
			} else {
				state.reasonsToPlay = [...state.reasonsToPlay, action.payload];
			}
		},
		updateReasonToPlay: (state, action) => {
			const index = state.reasonsToPlay.findIndex(reasonToPlay => reasonToPlay.id === action.payload.id);
			if (index >= 0) {
				state.reasonsToPlay = [
					...state.reasonsToPlay.slice(0, index),
					action.payload,
					...state.reasonsToPlay.slice(index + 1),
				];
			}
		},
		deleteReasonToPlay: (state, action) => {
			if (action.payload.reasons.length > 0) {
				const index = state.reasonsToPlay.findIndex(element => element.id === action.payload.id);
				if (index >= 0) {
					state.reasonsToPlay = [
						...state.reasonsToPlay.slice(0, index),
						action.payload,
						...state.reasonsToPlay.slice(index + 1),
					];
				}
			} else {
				const filteredReasonsToPlay = state.reasonsToPlay.filter(reasonToPlay => reasonToPlay.id !== action.payload.id);
				state.reasonsToPlay = [...filteredReasonsToPlay];
			}
		},
		moveToReasonInPlay: (state, action) => {
			return {
				...state,
				reasonInPlay: action.payload,
			};
		},
		updateMainClaim: (state, action) => {
			return {
				...state,
				mainClaim: {
					...state.mainClaim,
					mainClaim: action.payload.mainClaim,
				},
			};
		},
		updateReasonInPlay: (state, action) => {
			return {
				...state,
				reasonInPlay: action.payload ? Object.assign({}, state.reasonInPlay, action.payload) : null,
			};
		},
		updateReasonInPlayVotes: (state, action) => {
			return {
				...state,
				reasonInPlay: Object.assign({}, state.reasonInPlay, action.payload),
			};
		},
		updateCommonGrounds: (state, action) => {
			return {
				...state,
				commonGrounds: { ...action.payload },
			};
		},
		setFinalResults: (state, action) => {
			return {
				...state,
				results: action.payload,
			};
		},
		updatePriority: (state, action) => {
			return {
				...state,
				reasonToPlay: action.payload,
			};
		},
		emitStartGame: () => {},
		emitJoinGame: () => {},
		emitVote: () => {},
		emitUpdateMainClaim: () => {},
		emitVoteConvinced: () => {},
		emitVoteNotPersuaded: () => {},
		emitAddReasonToPlay: () => {},
		emitMoveToReasonInPlay: () => {},
		emitUpdateReasonToPlay: () => {},
		emitUpdateReasonToPlayPriorities: () => {},
		emitDeleteReasonToPlay: () => {},
		emitUpdateReasonInPlay: () => {},
		emitVoteEstablishedReasonInPlay: () => {},
		emitVoteContestedReasonInPlay: () => {},
		emitVoteNonGermaneReasonInPlay: () => {},
		emitMoveRIPToCommonGround: () => {},
		emitUpdateCommonGroundPriorities: () => {},
		emitMoveRIPToDissensus: () => {},
		emitMoveCommonGroundToReasonInPlay: () => {},
		emitChangeGamePhase: () => {},
		emitGetFinalResults: () => {},
		emitExitGame: () => {},
	},
});

export const {
	setRoomCode,
	initGame,
	editMainClaim,
	addReasonToPlay,
	updateReasonToPlay,
	changeGamePhase,
	emitStartGame,
	emitJoinGame,
	emitVote,
	emitUpdateMainClaim,
	emitAddReasonToPlay,
	emitVoteConvinced,
	emitVoteNotPersuaded,
	emitMoveToReasonInPlay,
	emitUpdateReasonToPlay,
	emitUpdateReasonToPlayPriorities,
	emitDeleteReasonToPlay,
	emitUpdateReasonInPlay,
	emitVoteEstablishedReasonInPlay,
	emitVoteContestedReasonInPlay,
	emitVoteNonGermaneReasonInPlay,
	emitMoveRIPToCommonGround,
	emitMoveRIPToDissensus,
	emitUpdateCommonGroundPriorities,
	emitMoveCommonGroundToReasonInPlay,
	emitChangeGamePhase,
	emitGetFinalResults,
	emitExitGame,
} = gameSlice.actions;

export default gameSlice.reducer;
